import styled from 'styled-components'

function BaseVideoCameraIcon({ className, size = 24, ...rest }: IconComponentProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        d="M4 5h9a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3m-1 3v8a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1m18.4-1.2a1 1 0 0 1 1.6.8v8.8a1 1 0 0 1-1.6.8L17 14.5v-5z"
        fill="currentColor"
      />
    </svg>
  )
}

export const VideoCameraIcon = styled(BaseVideoCameraIcon)``
